import { BaseService } from './base'
import { APIPath } from '../constant'

class SectionWorkflow {
    getSectionStatus(auditId, templateUniqueId) {
        return BaseService.get(
            APIPath.auditSectionStatus(auditId, templateUniqueId),
        )
    }

    getWorkflow(templateUniqueId) {
        return BaseService.get(
            APIPath.templateSectionWorkflow(templateUniqueId),
        )
    }

    saveWorkflow(templateUniqueId, assignments) {
        return BaseService.postExact(
            APIPath.templateSectionWorkflow(templateUniqueId),
            {
                TemplateUniqueId: Number(templateUniqueId),
                Assignments: assignments,
            },
        )
    }

    getNotificationRecipients(templateUniqueId, sectionId) {
        return BaseService.get(
            APIPath.sectionNotificationRecipients(
                templateUniqueId,
                sectionId,
            ),
        )
    }

    saveNotificationRecipients(templateUniqueId, sectionId, recipients) {
        return BaseService.postExact(
            APIPath.sectionNotificationRecipients(
                templateUniqueId,
                sectionId,
            ),
            { Recipients: recipients },
        )
    }

    searchUsers({ q = '', companyId = '', limit = 25 } = {}) {
        const cappedLimit = Math.min(Math.max(Number(limit) || 25, 1), 200)
        const params = new URLSearchParams()
        params.set('q', String(q ?? ''))
        if (companyId != null && String(companyId).trim() !== '') {
            params.set('companyId', String(companyId))
        }
        params.set('limit', String(cappedLimit))
        return BaseService.get(`${APIPath.userSearch}?${params.toString()}`)
    }

    completeSection(auditId, sectionId, templateUniqueId, notes = '') {
        // No body — notes in query string; postExact avoids LoginSource injection.
        return BaseService.postExact(
            APIPath.auditSectionComplete(
                auditId,
                sectionId,
                templateUniqueId,
                notes,
            ),
            undefined,
        )
    }

    uncompleteSection(auditId, sectionId, templateUniqueId) {
        return BaseService.postExact(
            APIPath.auditSectionUncomplete(
                auditId,
                sectionId,
                templateUniqueId,
            ),
            undefined,
        )
    }

    reportSectionEdit(payload) {
        return BaseService.postExact(APIPath.auditSectionEdit, payload)
    }
}

const SectionWorkflowService = new SectionWorkflow()
Object.freeze(SectionWorkflowService)
export { SectionWorkflowService }
